// Material Category Types
export const GET_LIST_MATERIAL_CATEGORY = '@@get_List_Material_Category';
export const GET_LIST_MATERIAL_CATEGORY_SUCCESS = '@@get_List_Material_Category_Success';
export const GET_LIST_MATERIAL_CATEGORY_FAILURE = '@@get_List_Material_Category_Failure';

// Get All Materials Types
export const GET_ALL_MATERIALS = '@@get_All_Materials';
export const GET_ALL_MATERIALS_SUCCESS = '@@get_All_Materials_Success';
export const GET_ALL_MATERIALS_FAILURE = '@@get_All_Materials_Failure';

// Generate Material Report Types
export const GENERATE_MATERIAL_REPORT = '@@generate_Material_Report';
export const GENERATE_MATERIAL_REPORT_SUCCESS = '@@generate_Material_Report_Success';
export const GENERATE_MATERIAL_REPORT_FAILURE = '@@generate_Material_Report_Failure';
export const CLEAR_GENERATE_MATERIAL_REPORT = '@@clear_Generate_Material_Report';

// Get Material Report Versions Types
export const GET_MATERIAL_REPORT_VERSIONS = '@@get_Material_Report_Versions';
export const GET_MATERIAL_REPORT_VERSIONS_SUCCESS = '@@get_Material_Report_Versions_Success';
export const GET_MATERIAL_REPORT_VERSIONS_FAILURE = '@@get_Material_Report_Versions_Failure';

// Generate Material Registry Report Types (Equipment/Consumable)
export const GENERATE_MATERIAL_REGISTRY_REPORT = '@@generate_Material_Registry_Report';
export const GENERATE_MATERIAL_REGISTRY_REPORT_SUCCESS = '@@generate_Material_Registry_Report_Success';
export const GENERATE_MATERIAL_REGISTRY_REPORT_FAILURE = '@@generate_Material_Registry_Report_Failure';
export const CLEAR_MATERIAL_REGISTRY_REPORT = '@@clear_Material_Registry_Report';

// Get Registry Report Versions Types (new API)
export const GET_REGISTRY_REPORT_VERSIONS = '@@get_Registry_Report_Versions';
export const GET_REGISTRY_REPORT_VERSIONS_SUCCESS = '@@get_Registry_Report_Versions_Success';
export const GET_REGISTRY_REPORT_VERSIONS_FAILURE = '@@get_Registry_Report_Versions_Failure';

// Get Inspection Personnel Documents Types (QC Inspection Personnel)
export const GET_INSPECTION_PERSONNEL_DOCUMENTS = '@@get_Inspection_Personnel_Documents';
export const GET_INSPECTION_PERSONNEL_DOCUMENTS_SUCCESS = '@@get_Inspection_Personnel_Documents_Success';
export const GET_INSPECTION_PERSONNEL_DOCUMENTS_FAILURE = '@@get_Inspection_Personnel_Documents_Failure';

// Get Registry Book Versions Types (previously generated registry books)
export const GET_REGISTRY_BOOK_VERSIONS = '@@get_Registry_Book_Versions';
export const GET_REGISTRY_BOOK_VERSIONS_SUCCESS = '@@get_Registry_Book_Versions_Success';
export const GET_REGISTRY_BOOK_VERSIONS_FAILURE = '@@get_Registry_Book_Versions_Failure';

// Get Material Registry Report Versions Types (for /material-registry-documents endpoint)
export const GET_MATERIAL_REGISTRY_REPORT_VERSIONS = '@@get_Material_Registry_Report_Versions';
export const GET_MATERIAL_REGISTRY_REPORT_VERSIONS_SUCCESS = '@@get_Material_Registry_Report_Versions_Success';
export const GET_MATERIAL_REGISTRY_REPORT_VERSIONS_FAILURE = '@@get_Material_Registry_Report_Versions_Failure';

// Pipe Dashboard - Material Traceability All Summary & Data
export const GET_MATERIAL_TRACEABILITY_ALL_SUMMARY = '@@get_Material_Traceability_All_Summary';
export const GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_SUCCESS = '@@get_Material_Traceability_All_Summary_Success';
export const GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_FAILURE = '@@get_Material_Traceability_All_Summary_Failure';
export const GET_MATERIAL_TRACEABILITY_ALL_DATA = '@@get_Material_Traceability_All_Data';
export const GET_MATERIAL_TRACEABILITY_ALL_DATA_SUCCESS = '@@get_Material_Traceability_All_Data_Success';
export const GET_MATERIAL_TRACEABILITY_ALL_DATA_FAILURE = '@@get_Material_Traceability_All_Data_Failure';
